/* eslint-disable */

import { combineReducers } from 'redux';
import storeProps from './reducers/reducer';

export default combineReducers({
	storeProps,
});
